import React from 'react';

const Timesheet = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    className="icon timesheet"
  >
    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976c.383.098.756.225 1.117.375l-.35.945a7 7 0 0 0-.732-.176zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576a7 7 0 0 0-.546-.592zm.743 1.756a7 7 0 0 0-.214-.468l.931-.4a8 8 0 0 1 .43 1.047l-.911.284a7 7 0 0 0-.236-.463zM8 4.5a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .146.354l2.5 2.5a.5.5 0 0 0 .708-.708L8.5 7.707V5a.5.5 0 0 0-.5-.5" />
    <path d="M.5 8a7.5 7.5 0 1 1 15 0A7.5 7.5 0 0 1 .5 8m7.5-6.5A6.5 6.5 0 1 0 14.5 8 6.5 6.5 0 0 0 8 1.5" />
  </svg>
);

export default Timesheet;
